import { useContext, useEffect } from 'react'
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import { CoordinateConverter } from '../../../../../util/coordinateConverter';
import {Cartesian3, Math} from 'cesium';

interface Props {
    camera_position: number[];
    target_position: number[];
}

export default function Camera(props: Props) {
    const viewer = useContext(CesiumViewerContext)
    const converter = new CoordinateConverter();
    useEffect(() => {
        if (!viewer) {
            return;
        }
        if (props.camera_position === null) {
            return;
        }
        if (props.target_position === null) {
            return;
        }
        const target = Cartesian3.fromDegrees(
            props.target_position[0], 
            props.target_position[1], 
            props.target_position[2], 
        );
	const camera = Cartesian3.fromDegrees(
            props.camera_position[0], 
            props.camera_position[1], 
            props.camera_position[2], 
        );
        viewer.camera.flyTo({
            destination: camera,
            orientation: {
                heading: Math.toRadians(0.0),
                pitch: Math.toRadians(-90),
                roll: 0.0
            }
        });
    }, [viewer, props.camera_position, props.target_position])

    return null;
}
